import { cn } from '@/shared/lib/cn';

/** Вид поля ввода — общий для полей и для того, что выглядит как поле. */
export const CONTROL_BASE = cn(
  'w-full rounded-md bg-surface-2 px-3.5 text-[15px] text-content',
  'border border-border placeholder:text-subtle',
  'transition-[border-color,box-shadow] duration-150 outline-none',
  'focus:border-brand focus:ring-2 focus:ring-brand/25',
  'disabled:opacity-50',
);

/**
 * Строка, которая раскрывается по стрелке, — выглядит как поле: той же высоты
 * и рамки, что и выпадающий список рядом.
 */
export const FIELD_TRIGGER = 'h-11 rounded-md border border-border bg-surface-2 px-3.5';
